import React from 'react';
import appConfig from '../../app-config';

import './splash.scss';

export default class Splash extends React.Component {
  render() {
    return (
      <div className={'splash-header'}>
        <div className={'title'}>{appConfig.app.title}</div>
        <div>version {appConfig.app.version}</div>
      </div>
    );
  }
}